var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-chip-miltiple"},[_vm._l((_vm.lessons),function(lesson){return _c('lesson-chip-multiple-item',{key:lesson['@id'],attrs:{"lesson":lesson}})}),(_vm.hiddenEntriesCount > 0)?_c('div',{staticClass:"hidden-entries-count"},[_vm._v(" +"+_vm._s(_vm.hiddenEntriesCount)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }